<template>
    <div class="language">
        <div class="cht" :class="{'active':choose=='cht'}" @click="chooseLanguage('cht')">繁體中文</div>
        <div class="en" :class="{'active':choose=='en'}" @click="chooseLanguage('en')">ENGLISH</div>
    </div>
</template>

<script>
export default {
    name: "language",
    components: {},
    props: {},
    data() {
        return {
            choose: "cht"
        };
    },
    methods: {
        chooseLanguage: function(e) {
            this.choose = e;
            this.$emit("getLanguage", e);
        }
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.language {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    margin-bottom: 10px;
}
.language div {
    padding: 0 15px;
    cursor: pointer;
    font-size: 1.2rem;
    color: #bab1a2;
}
.language div.active {
    color: #ee8b59;
}
.language div + div {
    border-left: 1px solid rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/switchLanguage/index.vue